(() => {
  if (customElements.get('sembonia-menu-content')) return;
  let sequence = 0;
  const opened = new Set();
  const closing = new WeakSet();
  window.semboniaCloseMenu = (details, finish) => {
    if (!details?.querySelector('.sembonia-menu-panel')) return false;
    if (closing.has(details)) return true;
    if (!details.open) return false;
    closing.add(details);
    details.classList.add('sembonia-menu-closing');
    const complete = () => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening', 'sembonia-menu-closing');
      details.querySelector('summary')?.setAttribute('aria-expanded','false');
      closing.delete(details);
      finish?.();
    };
    if (window.semboniaMobileBaseline?.instantDrawers) complete();
    else setTimeout(complete, 500);
    return true;
  };
  function updateLock(element, open) {
    // The mobile shell and its content describe one drawer, not two locks.
    const owner = element.lockOwner || element;
    if (open && !opened.has(element)) {
      if (!opened.size) {
        document.documentElement.classList.add('sembonia-menu-open');
      }
      opened.add(element);
      // Desktop/tablet menus do not use HeaderDrawer. Both variants participate.
      window.semboniaScrollLock.acquire(owner);
    } else if (!open && opened.delete(element)) {
      if (!opened.size) document.documentElement.classList.remove('sembonia-menu-open');
      window.semboniaScrollLock.release(owner);
      // Native disclosure changes and interrupted closes must clear shell state too.
      if (owner !== element) {
        owner.unlockPageScroll();
        owner.header?.classList.remove('menu-open');
        window.removeEventListener('resize', owner.onResize);
      }
    }
  }
  customElements.define('sembonia-menu-content', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const panels = [...this.querySelectorAll('[role="tabpanel"]')];
      const prefix = `sembonia-menu-${++sequence}`;
      const select = (selected, highlight = true) => {
        if (!selected) return;
        tabs.forEach(tab => {
          const active = tab === selected;
          tab.setAttribute('aria-selected', String(active));
          tab.dataset.active = String(active && highlight);
          tab.tabIndex = active ? 0 : -1;
        });
        panels.forEach(panel => { panel.hidden = panel.dataset.departmentPanel !== selected.dataset.department; });
      };
      tabs.forEach((tab,index) => {
        const panel = panels.find(panel => panel.dataset.departmentPanel === tab.dataset.department);
        tab.id = `${prefix}-tab-${index}`;
        if (panel) {
          panel.id = `${prefix}-panel-${index}`;
          tab.setAttribute('aria-controls', panel.id);
          panel.setAttribute('aria-labelledby', tab.id);
        }
        tab.addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); select(tab); }, options);
        tab.addEventListener('keydown', event => {
          const target = event.key === 'ArrowRight' ? (index+1)%tabs.length : event.key === 'ArrowLeft' ? (index+tabs.length-1)%tabs.length : event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length-1 : -1;
          if (target < 0) return;
          event.preventDefault(); select(tabs[target]); tabs[target].focus();
        }, options);
      });
      // Keep Sale's page semantics separate from the drawer's selected tab.
      const collectionPath = value => {
        try {
          const path = new URL(value, document.baseURI).pathname.replace(/\/$/, '');
          return path.match(/^(.*\/collections\/[^/]+)/)?.[1] || path;
        } catch (_) { return ''; }
      };
      const currentPath = collectionPath(window.location.href);
      const sale = this.querySelector('.sembonia-menu-sale');
      const isSale = !!sale && collectionPath(sale.href) === currentPath;
      if (sale) {
        if (isSale) sale.setAttribute('aria-current', 'page');
        else sale.removeAttribute('aria-current');
      }
      // Women is the default drawer tab on every page, with a selected underline.
      select(tabs.find(tab => tab.dataset.department === 'women') || tabs[0]);
      this.panel = this.closest('.sembonia-menu-panel');
      this.panel?.setAttribute('data-lenis-prevent', '');
      this.disclosure = this.closest('details');
      this.lockOwner = this.closest('header-drawer') || this;
      this.querySelector('.sembonia-menu-close')?.addEventListener('click', event => this.closeMenu(event), options);
      this.observer = new MutationObserver(() => updateLock(this, !!this.disclosure?.open));
      if (this.disclosure) this.observer.observe(this.disclosure, {attributes:true, attributeFilter:['open']});
      updateLock(this, !!this.disclosure?.open);
    }
    closeMenu(event) {
      event.preventDefault();
      event.stopPropagation();
      if (!this.disclosure?.open) return;
      const summary = this.disclosure.querySelector('summary');
      const drawer = this.closest('header-drawer');
      if (drawer) {
        // HeaderDrawer owns an additional scroll lock and header state on mobile.
        drawer.closeMenuDrawer(event, summary);
        return;
      }
      window.semboniaCloseMenu(this.disclosure, () => {
        updateLock(this, false);
        removeTrapFocus();
        summary?.focus({preventScroll:true});
      });
    }
    disconnectedCallback() {
      this.observer?.disconnect(); this.controller?.abort(); this.controller = null;
      updateLock(this, false);
    }
  });
})();
